import { TiFlowSwitch } from "react-icons/ti";

export default PipelineV2RunsEmpty;

function PipelineV2RunsEmpty() {
  return (
    <div className="flex h-[40dvh] w-full items-center justify-center mx-auto border rounded-lg">
      <div className="flex flex-col items-center">
        <TiFlowSwitch className="size-10 mr-1 text-gray-500" />
        <p className="font-medium text-md text-gray-500">No Pipeline Runs</p>
      </div>
    </div>
  );
}
